import Vue from 'vue'
import MintUI from 'mint-ui'
import App from './index.vue'
import 'mint-ui/lib/style.css'
import '@/assets/js/inobounce.js'
import api from '../../utils/api'

import loading from '@/components/loading'

Vue.use(MintUI)
Vue.prototype.$loading = loading
Vue.prototype.api = api
Vue.config.productionTip = false

new Vue({
  el: '#app',
  components: { App },
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js